import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-garbage",
  "use": "icon-garbage-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-garbage\">\n  <path d=\"M6 12V6H7V12H6Z\" fill=\"#878787\" fill-opacity=\"0.9\" />\n  <path d=\"M9 6V12H10V6H9Z\" fill=\"#878787\" fill-opacity=\"0.9\" />\n  <path d=\"M10.5 3H14V4H13V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V4H2V3H5.5L5.5 1.8C5.5 1.35817 5.85817 1 6.3 1H9.7C10.1418 1 10.5 1.35817 10.5 1.8V3ZM6.5 3H9.5L9.5 2L6.5 2V3ZM4 4V14H12V4H4Z\" fill=\"#878787\" fill-opacity=\"0.9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol